import { rem } from "@myphx-engineering/phx-design-system/framework";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/internal/MedFormIcon.tsx
const InternalMedFormIcon = ({ alt, svgFile }) => {
	return /* @__PURE__ */ jsx("img", {
		src: `/static/libraries/myphx-lib/med-form-icons/${svgFile}`,
		"aria-label": alt,
		style: {
			height: rem("24px"),
			width: rem("24px")
		},
		"data-testid": "med-form-icon"
	});
};

//#endregion
export { InternalMedFormIcon };